import { render, staticRenderFns } from "./OptionsAddEdit.vue?vue&type=template&id=350a20b6&scoped=true&"
import script from "./OptionsAddEdit.vue?vue&type=script&lang=js&"
export * from "./OptionsAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./OptionsAddEdit.vue?vue&type=style&index=0&id=350a20b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a20b6",
  null
  
)

export default component.exports